export const PlatformUpdatesForm = {
  OPEN_PLATFORM_UPDATES_MODAL: "OPEN_PLATFORM_UPDATES_MODAL",
  CLOSE_PLATFORM_UPDATES_MODAL: "CLOSE_PLATFORM_UPDATES_MODAL",
};
